import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const CreateAlbum = () => {
  const navigate = useNavigate();
  const [albumName, setAlbumName] = useState("");
  const [photos, setPhotos] = useState([]);

  // Handle file selection
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setPhotos(files);
  };

  // Handle album creation
  const handleSubmit = (event) => {
    event.preventDefault();

    if (!albumName || photos.length === 0) {
      alert("Please enter an album name and select photos!");
      return;
    }

    const newAlbum = {
      id: Date.now(),
      name: albumName,
      photos: photos.map((file) => URL.createObjectURL(file)), // Convert to local URL
    };

    // Save to localStorage
    const storedAlbums = JSON.parse(localStorage.getItem("albums")) || [];
    localStorage.setItem("albums", JSON.stringify([...storedAlbums, newAlbum]));

    // Navigate back to album list
    navigate("/login/assembly-gallery");
  };

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <h2>Create New Album</h2>
      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <input
          type="text"
          placeholder="Album Name"
          value={albumName}
          onChange={(e) => setAlbumName(e.target.value)}
          style={{ padding: "10px", margin: "10px 0", width: "80%" }}
          required
        />
        <input type="file" multiple accept="image/*" onChange={handleFileChange} style={{ marginBottom: "10px" }} />
        <button type="primary" style={{ padding: "10px 20px", background: "#1890ff", color: "white", border: "none", cursor: "pointer" }}>
          Create Album
        </button>
      </form>
    </div>
  );
};

export default CreateAlbum;
